<template>
  <div class="addMemberes">
    <el-form ref="form" :model="form" :rules="rules" label-width="160px">
      <el-row :gutter="120">
        <el-col :span="12">
          <el-form-item label="联系方式" prop="phone">
            <el-input
              placeholder="请输入联系方式"
              v-model="form.phone"
              style="width:230px"
              @blur="checkTel"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="称呼" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio :label="'2'">女士</el-radio>
              <el-radio :label="'1'">先生</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="120">
        <el-col :span="12">
          <el-form-item :label="$store.state.userInfo.brandId == 1 ?'会员姓名':'家长姓名'" prop="name">
            <el-input v-model="form.name" :placeholder="$store.state.userInfo.brandId == 1?'请输入会员姓名':'请输入家长姓名'" style="width:190px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="$store.state.userInfo.brandId == 1">
          <el-form-item label="生日" prop="memberBirth">
            <el-date-picker
              type="date"
              placeholder="月/日"
              format="MM 月 dd 日"
              v-model="form.memberBirth"
              style="width: 190px;"
              value-format="MM-dd"
            ></el-date-picker>
            <!-- <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="form.memberBirth" style="width: 190px;" value-format="timestamp"></el-date-picker> -->
          </el-form-item>
        </el-col>
      </el-row>
      <div class="adultMems" v-if="$store.state.userInfo.brandId == 1">
        <!-- 婷美21 -->
        <el-row :gutter="120">
          <el-col :span="12">
            <el-form-item label="年龄" prop="age">
              <el-input type="age" v-model="form.age" placeholder="请输入年龄" style="width:135px"></el-input>&nbsp;&nbsp;岁
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身高" prop="health.height">
              <el-input v-model="form.health.height" placeholder="请输入身高" style="width:135px"></el-input>&nbsp;&nbsp;cm
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120">
          <el-col :span="12">
            <el-form-item label="职业" prop="occupation">
              <el-input v-model="form.occupation" placeholder="请输入职业" style="width:190px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="体重" prop="health.weight">
              <el-input v-model="form.health.weight" placeholder="请输入体重" style="width:135px"></el-input>&nbsp;&nbsp;Kg
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="血型" prop="health.bloodType">
              <el-select v-model="form.health.bloodType" placeholder="请选择血型" style="width:190px;">
                <el-option label="A" value="A"></el-option>
                <el-option label="B" value="B"></el-option>
                <el-option label="O" value="O"></el-option>
                <el-option label="AB" value="AB"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="孩子1出生日期" prop="childoneBirth">
              <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="form.childoneBirth" style="width: 190px;" value-format="MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="孩子2出生日期" prop="sonmemberBirth">
              <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="form.sonmemberBirth" style="width: 190px;" value-format="MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label="结婚纪念日" prop="weddingDay">
              <el-date-picker type="date" placeholder="月/日" format="MM 月 dd 日" v-model="form.weddingDay" style="width: 190px;" value-format="MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>          
        </el-row>
        <el-row :gutter="120" class="borTop">
          <el-col :span="12">
            <el-form-item label="所处阶段" prop="health.procreate">
              <el-radio-group v-model="form.health.procreate" class="myselectTgas">
                <el-radio-button label="3">孕前</el-radio-button>
                <el-radio-button label="1">妊娠</el-radio-button>
                <el-radio-button label="2">产后</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="月经周期" prop="health.menstrual" v-if="form.health.procreate == 3">
              <el-input placeholder="请输入月经周期" style="width:135px" v-model="form.health.menstrual"></el-input>&nbsp;&nbsp;天
            </el-form-item>
            <el-form-item
              label="预产期"
              prop="health.expectedDate"
              v-else-if="form.health.procreate == 1"
            >
              <el-date-picker
                type="date"
                placeholder="年/月/日"
                format="yyyy 年 MM 月 dd 日"
                v-model="form.health.expectedDate"
                style="width: 190px;"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="生产日期" prop="health.dueDate" v-else-if="form.health.procreate == 2">
              <el-date-picker
                type="date"
                placeholder="年/月/日"
                format="yyyy 年 MM 月 dd 日"
                v-model="form.health.dueDate"
                style="width: 190px;"
                value-format="timestamp"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120" v-if="form.health.procreate == 2">
          <el-col :span="12">
            <el-form-item label="生产方式" prop="health.dueStyle">
              <el-radio-group v-model="form.health.dueStyle" class="myselectTgas">
                <el-radio-button label="1">顺产</el-radio-button>
                <el-radio-button label="2">剖宫产</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="母乳时长" prop="health.lactation">
              <el-input v-model="form.health.lactation" placeholder="请输入母乳时长" style="width:135px"></el-input>&nbsp;&nbsp;个月
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120" class="borTop">
          <el-col :span="24">
            <el-form-item label="皮肤状态" prop="health.skins">
              <el-checkbox-group v-model="form.health.skins" class="myselectTgas">
                <el-checkbox-button v-for='i in infolist.skinCondition' :key="i.skinId" :label="i.skinId">{{i.skinStatus}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120" class="borTop">
          <el-col :span="24">
            <el-form-item label="体型" prop="health.shapes">
              <el-checkbox-group v-model="form.health.shapes" class="myselectTgas">
                <el-checkbox-button v-for='i in infolist.shapelist' :label="i.shapeId" :key="i.shapeId">{{i.isChecked}}{{i.shapeName}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="经常食用以下类型食物" prop="health.foods">
              <el-checkbox-group v-model="form.health.foods" class="myselectTgas">
                <el-checkbox-button v-for='i in infolist.foodlist' :key="i.foodId" :label="i.foodId">{{i.foodName}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="乳房情况" prop="health.breasts">
              <el-checkbox-group v-model="form.health.breasts" class="myselectTgas">
                <el-checkbox-button v-for='i in infolist.breastlist' :key="i.breastId" :label="i.breastId">{{i.breastStatus}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="以下症状有无" prop="health.symptoms">
              <el-checkbox-group v-model="form.health.symptoms" class="myselectTgas">
                <el-checkbox-button v-for='i in infolist.symptomlist' :key="i.symptomsId" :label="i.symptomsId">{{i.symptomsName}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120" class="borTop">
          <el-col :span="12">
            <el-form-item label="吃早餐的习惯" prop="breakfast">
              <el-radio-group v-model="form.health.breakfast">
                <el-radio label="1">有</el-radio>
                <el-radio label="0">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="吃夜宵的习惯" prop="snack">
              <el-radio-group v-model="form.health.snack">
                <el-radio label="1">有</el-radio>
                <el-radio label="0">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="经常入睡时间" prop="bedtime">
              <el-radio-group v-model="form.health.bedtime">
                <el-radio label="1">23点前</el-radio>
                <el-radio label="0">23点后</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="睡眠时间" prop="sleepTime">
              <el-radio-group v-model="form.health.sleepTime">
                <el-radio label="3">8小时</el-radio>
                <el-radio label="1">8小时以下</el-radio>
                <el-radio label="2">8小时以上</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="服用减肥药品/食品" :prop="form.health.eatDietFood == 1?'health.dietFood':'no'">
              <el-radio-group v-model="form.health.eatDietFood">
                <el-radio label="1">有</el-radio>
                <el-radio label="0">无</el-radio>
              </el-radio-group>&nbsp;&nbsp;
              <el-input v-if="form.health.eatDietFood == 1" v-model="form.health.dietFood" placeholder="具体什么药品/食品" style="width:190px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="月经期是否规律" :prop="form.health.menstrualNormal == 1 ? 'health.menstrualContent':'no'">
              <el-radio-group v-model="form.health.menstrualNormal">
                <el-radio label="1">有</el-radio>
                <el-radio label="0">无</el-radio>
              </el-radio-group>
              <el-input
                type="textarea"
                v-if="form.health.menstrualNormal == 1"
                v-model="form.health.menstrualContent"
                style="height:100px;"
                placeholder="具体情况"
                resize="none"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="120" class="borTop">
          <el-col :span="12">
            <el-form-item label="需改善部位" prop="health.organList">
              <el-checkbox-group v-model="form.health.organList" class="myselectTgas">
                <el-checkbox-button v-for="(p,index) in patrs" :label="p.id" :key="index">{{p.name}}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="会员备注" prop="health.remarks">
              <el-input
                type="textarea"
                v-model="form.health.remarks"
                style="height:180px;"
                placeholder="建议填写用户当前身体的综合情况，300个汉字长度以内"
                resize="none"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="childMemes" v-else>
        <!-- 儿推 -->
        <div class="childList" v-for="(i,index) in form.childList" :key="index">
          <el-row :gutter="120" class="borTop" style="position:relative">
            <el-col :span="12">
              <div class="childTitle">孩子{{index + 1}} 信息</div>
            </el-col>
            <div class="deleteChild" @click="deleteOneChild(index)" v-if="index > 0"></div>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="12">
              <el-form-item
                label="姓名"
                :prop="'childList.' + index + '.childName'"
                :rules="rules.childList.childName"
              >
                <el-input v-model="i.childName" placeholder="请输入姓名" style="width:135px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="生日"
                :prop="'childList.' + index + '.childBirth'"
                :rules="rules.childList.childBirth"
              >
                <el-date-picker
                  type="date"
                  placeholder="年/月/日"
                  format="yyyy 年 MM 月 dd 日"
                  v-model="i.childBirth"
                  style="width:190px"
                  value-format="timestamp"
                ></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="12">
              <el-form-item
                label="性别"
                :prop="'childList.' + index + '.childSex'"
                :rules="rules.childList.childSex"
              >
                <el-radio-group v-model="i.childSex">
                  <el-radio :label="'1'">男孩</el-radio>
                  <el-radio :label="'2'">女孩</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item label="关系" :prop="'childList.' + index + '.relationship'" :rules="rules.childList.relationship">
                <el-select v-model="i.relationshipId" placeholder="请选择关系" style="width:190px;">
                  <el-option v-for="list in infolist.relationshiplist" :key="list.relationshipId" :label="list.relationship" :value="list.relationshipId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="身高"
                :prop="'childList.' + index + '.health.height'"
                :rules="rules.childList.health.height"
              >
                <el-input v-model="i.health.height" placeholder="请输入身高" style="width:135px"></el-input>&nbsp;&nbsp;cm
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="体重"
                :prop="'childList.' + index + '.health.weight'"
                :rules="rules.childList.health.weight"
              >
                <el-input v-model="i.health.weight" placeholder="请输入体重" style="width:135px"></el-input>&nbsp;&nbsp;Kg
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="9">
              <el-form-item
                label="是否有禁忌症"
                :prop="'childList.' + index + '.health.isContraindication'"
                :rules="rules.childList.health.isContraindication"
              >
                <el-radio-group v-model="i.health.isContraindication">
                  <el-radio label="0">无</el-radio>
                  <el-radio label="1">有</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span='12'>
              <el-form-item
                label-width="0px"
                v-if="i.health.isContraindication == 1"
                :prop="'childList.' + index + '.health.contraindications'"
                :rules="rules.childList.health.contraindications"
              >
                <el-input v-model="i.health.contraindications" placeholder="请输入禁忌症" style="width:220px"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="24">
              <el-form-item
                label="发育情况"
                :prop="'childList.' + index + '.health.develop'"
                :rules="rules.childList.health.develop"
              >
                <el-radio-group v-model="i.health.develop" class="myselectTgas">
                  <el-radio-button label="1">下</el-radio-button>
                  <el-radio-button label="2">中下</el-radio-button>
                  <el-radio-button label="3">中</el-radio-button>
                  <el-radio-button label="4">中上</el-radio-button>
                  <el-radio-button label="5">上</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                label="缓解症状"
                :prop="'childList.' + index + '.health.symptoms'"
                :rules="rules.childList.health.symptoms"
              >
                <el-checkbox-group v-model="i.health.symptoms" class="myselectTgas">
                  <el-checkbox-button v-for="list in infolist.symptomslist" :key="list.symptomsId" :label="list.symptomsId">{{list.symptomsName}}</el-checkbox-button>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="120">
            <el-col :span="24">
              <el-form-item
                label="会员备注"
                :prop="'childList.' + index + '.health.remarks'"
                :rules="rules.childList.health.remarks"
              >
                <el-input
                  type="textarea"
                  v-model="i.health.remarks"
                  style="height:80px;"
                  placeholder="建议填写孩子的病症，及其相关的信息，300个汉字长度以内"
                  resize="none"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="myChild">
          <el-button class="addChild" @click="addChildlist">添加孩子</el-button>
        </el-row>
      </div>
      <el-row class="btnOptions" v-if="this.editFlag">
        <el-button class="darkBtn" @click="cancelEdit">取消</el-button>
        <el-button class="redBtn" @click="submitEdit">提交</el-button>
      </el-row>
      <el-row class="btnOptions" v-else>
        <el-button class="darkBtn" @click="resetData">重置</el-button>
        <el-button class="redBtn" :disabled="clickFalg" @click="onSubmit">确定</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import infolist from '@/assets/js/info'
import { searchOrgan, insertMem, memDetail, updateMem } from "@/api";
export default {
  data() {
    /*验证手机号*/
    const isvalidateMobile = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^1[3456789]\d{9}$/.test(value) == false) {
          callback(new Error("请输入正确的手机号"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字(正整数)
    const isvalidateNumber = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^[1-9]\d*$/.test(value) == false) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    // 数字(一位小数，身高/体重/母乳时长)
    const isvalidateNumberPoint = (rule, value, callback) => {
      if (value != null && value != "") {
        if (/^\d*\.{0,1}\d{0,1}$/.test(value) == false) {
          callback(new Error("请输入数字，最多一位小数"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    //限制300字以内
    const isvalidateLimit = (rule, value, callback) => {
      if (value && value.length > 300) {
        callback(new Error("最多 300 个汉字长度"));
      } else {
        callback();
      }
    };
    return {
      infolist:infolist,
      form: {
        phone: "",
        name: "",
        sex: "2",
        memberBirth: "",
        childoneBirth:'',
        sonmemberBirth:'',
        weddingDay:'',
        age: "",
        occupation:'',
        health: {
          height: "",
          weight: "",
          bloodType:'',
          shapes: [],
          foods:[],
          breasts:[],
          symptoms:[],
          skins:[],
          breakfast:'',
          snack:'',
          bedtime:'',
          sleepTime:'',
          eatDietFood:'',
          dietFood:'',
          menstrualNormal:'',
          procreate: "",
          menstrual: "",
          expectedDate: "",
          dueDate: "",
          dueStyle: "",
          lactation: "",
          organList: [],
          remarks: "",
          menstrualContent:''
        },
        childList: [
          {
            childName: "",
            childSex: "1",
            childBirth: "",
            relationship:'',
            relationshipId:'',
            health: {
              height: "",
              weight: "",
              develop: "",
              isContraindication:'',
              contraindications:'',
              symptoms:[],
              remarks: "",
            }
          }
        ]
      },
      patrs: [],
      rules: {
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: "blur"
          },
          { validator: isvalidateMobile, trigger: "blur" }
        ],
        sex: [{ required: true, message: "请选择您的称呼", trigger: "change" }],
        name: [
          { required: true, message: "请输入会员姓名", trigger: "blur" },
          {
            min: 0,
            max: 15,
            message: "最多 15 个字符",
            trigger: "blur"
          }
        ],
        age: [
          { required: true, message: "请输入年龄", trigger: "blur"},
          { type: "number", validator: isvalidateNumber, trigger: "blur" }
        ],
        memberBirth:[
          { required: true, message: "请选择生日", trigger: "change"}
        ],
        health: {
          dietFood:[
            { required: true, message: "请输入具体药品/食品", trigger: "blur" },
          ],
          height: [
            { required: true, message: "请输入身高", trigger: "blur"},
            {
              type: "number",
              validator: isvalidateNumberPoint,
              trigger: "blur"
            }
          ],
          weight: [
            {
              type: "number",
              validator: isvalidateNumberPoint,
              trigger: "blur"
            }
          ],
          procreate: [
            { required: true, message: "请选择所处阶段", trigger: "change" }
          ],
          menstrual: [
            {
              required: true,
              message: "请输入月经周期",
              trigger: "blur"
            },
            { validator: isvalidateNumber, trigger: "blur" }
          ],
          expectedDate: [
            {
              required: true,
              message: "请选择预产期",
              trigger: "change"
            }
          ],
          dueDate: [
            {
              required: true,
              message: "请选择生产日期",
              trigger: "change"
            }
          ],
          dueStyle: [
            { required: true, message: "请选择生产方式", trigger: "change" }
          ],
          lactation: [
            {
              required: true,
              message: "请输入母乳时长",
              trigger: "blur"
            },
            { validator: isvalidateNumberPoint, trigger: "blur" }
          ],
          remarks: [{ validator: isvalidateLimit, trigger: "blur" }],
          menstrualContent:[
            { required: true, message: "请输入具体情况", trigger: "blur" },
            { validator: isvalidateLimit, trigger: "blur" }
          ]
        },
        childList: {
          childName: [
            { required: true, message: "请输入孩子姓名", trigger: "blur" },
            {
              min: 0,
              max: 15,
              message: "最多 15 个字符",
              trigger: "blur"
            }
          ],
          childBirth: [
            {
              required: true,
              message: "请选择生日",
              trigger: "change"
            }
          ],
          childSex: [
            { required: true, message: "请选择孩子性别", trigger: "change" }
          ],          
          health: {            
            height: [
              {
                type: "number",
                validator: isvalidateNumberPoint,
                trigger: "blur"
              }
            ],
            weight: [
              {
                type: "number",
                validator: isvalidateNumberPoint,
                trigger: "blur"
              }
            ],
            remarks: [{ validator: isvalidateLimit, trigger: "blur" }],
            contraindications:[
              { required: true, message: "请输入禁忌症", trigger: "blur" },
              {
                min: 0,
                max: 50,
                message: "最多 50 个字符",
                trigger: "blur"
              }
            ]
          }
        }
      },
      editFlag: false, //是否编辑页面false为新增页true编辑页
      clickFalg:false
    };
  },
  watch: {
    $route(to) {
      if (to.meta.edit) {
        this.editFlag = true;
        this.editData();
      } else {
        this.editFlag = false;
        this.$refs.form.resetFields();
        this.form = Object.assign({}, this.$options.data().form);
      }
    }
  },
  mounted() {
    if (this.$route.meta.edit) {
      this.editFlag = true;
      this.editData();
    } else {
      this.editFlag = false;
      this.$refs.form.resetFields();
      this.form = Object.assign({}, this.$options.data().form);
    }
    if (this.$store.state.userInfo.brandId == 1) {
      this.part();
    }    
  },
  computed: {
    options() {
      return this.$store.state.options;
    },
    activeIndex: {
      get() {
        return this.$store.state.activeIndex;
      },
      set(val) {
        this.$store.commit("set_active_index", val);
      }
    },
    computedList(){
      return (val,type)=>{
        let data = [];
        if(val){
          for(let m of val){
            data.push(type == 1 ? m.skinId:(type == 2?m.shapeId:(type == 3 ? m.foodId:(type == 4?m.breastId:m.symptomsId))))
          }
        }
        return data
      }
    },
    computedData(){
      return (val,allData,type)=>{
        let data =[];
        for(let m of allData){
          for(let i of val){
            if(type == 1){
              if(m.skinId == i){
                data.push({
                  skinId:m.skinId,
                  skinStatus:m.skinStatus
                })
              }
            }else if(type == 2){
              if(m.shapeId == i){
                data.push({
                  shapeId:m.shapeId,
                  shapeName:m.shapeName
                })
              }
            }else if(type == 3){
              if(m.foodId == i){
                data.push({
                  foodId:m.foodId,
                  foodName:m.foodName
                })
              }
            }else if(type == 4){
              if(m.breastId == i){
                data.push({
                  breastId:m.breastId,
                  breastStatus:m.breastStatus
                })
              }
            }else if(type == 5){
              if(m.symptomsId == i){
                data.push({
                  symptomsId:m.symptomsId,
                  symptomsName:m.symptomsName
                })
              }
            }
          }
        }
        return data;
      }
    },
    submitDate(){
      let data = {};
      this.form.health.skins = this.computedData(this.form.health.skins,this.infolist.skinCondition,1)
      this.form.health.shapes = this.computedData(this.form.health.shapes,this.infolist.shapelist,2)
      this.form.health.foods = this.computedData(this.form.health.foods,this.infolist.foodlist,3)
      this.form.health.breasts = this.computedData(this.form.health.breasts,this.infolist.breastlist,4)
      this.form.health.symptoms = this.computedData(this.form.health.symptoms,this.infolist.symptomlist,5)
      if(this.form.health.menstrualNormal == 0){
        // 月经不规律的具体情况	
        this.form.health.menstrualContent = ''
      }
      if(this.form.health.eatDietFood == 0){
        // 吃减肥药品/食品		
        this.form.health.dietFood = ''
      }
      let childListBirth = [];
      if(this.form.childoneBirth){
        childListBirth.push({
          childId:this.form.childList && this.form.childList.length > 0 ?this.form.childList[0].childId:null,
          childBirth:this.form.childoneBirth
        })
      }
      if(this.form.sonmemberBirth){
        childListBirth.push({
          childId:this.form.childList && this.form.childList.length > 1 ?this.form.childList[1].childId:null,
          childBirth:this.form.sonmemberBirth
        })
      }
      data = {
        name: this.form.name,
        sex: this.form.sex,
        age: this.form.age,
        memberBirth: this.form.memberBirth,
        phone: this.form.phone,
        health: this.form.health,
        childList:childListBirth,
        weddingDay:this.form.weddingDay,
        occupation:this.form.occupation
      };
      return data;
    },
    childSubmitData(){
      let data = {};
      this.form.childList.forEach((m,index)=>{
        for(let id of this.infolist.relationshiplist){
          if(m.relationshipId == id.relationshipId){
            this.form.childList[index].relationship = id.relationship;
          }
        }
        m.health.symptoms = this.computedData(m.health.symptoms,this.infolist.symptomslist,5)
        if(m.health.isContraindication == 1){
          // 孩子是否有禁忌症 1有 0无	
          m.health.contraindications = ''
        }
      })
      data = {
        name: this.form.name,
        sex: this.form.sex,
        phone: this.form.phone,
        childList: this.form.childList
      };
      return data;
    }
  },
  methods: {
    part() {
      searchOrgan().then(res => {
        this.patrs = res.data;
      });
    },
    addChildlist() {
      // 添加孩子
      if(!this.form.childList){
        this.form.childList = [];
      }
      this.form.childList.push({
        childName: "",
        childSex: "1",
        childBirth: "",
        relationship:'',
        relationshipId:'',
        health: {
          height: "",
          weight: "",
          develop: "",
          isContraindication:'',
          contraindications:'',
          symptoms:[],
          remarks: "",
        }
      });
    },
    deleteOneChild(index) {
      // 删除孩子
      this.form.childList.splice(index, 1);
    },
    editData() {
      // 修改会员详情
      memDetail({
        memberId: this.$route.params.memId
      }).then(res => {
        if(res.code != 1){
          this.form = Object.assign(
                {},
                this.$options.data().form
              );
        }else{
          this.form = res.data;
          // this.form.health.dueDate = res.data.health.dueDate.replace(/\s+/g,"");
          // this.form.health.expectedDate = res.data.health.expectedDate.replace(/\s+/g,"");
          if (!res.data.health) {
            this.form.health = Object.assign(
              {},
              this.$options.data().form.health
            );
          } else {
            if (!res.data.health.organList) {
              this.form.health.organList = Object.assign(
                [],
                this.$options.data().form.health.organList
              );
            }
          }
          if (res.data.childList) {
            res.data.childList.forEach((i,index)=>{
              this.$set(this.form,'childoneBirth',res.data.childList[0]?res.data.childList[0].childBirth:'')
              this.$set(this.form,'sonmemberBirth',res.data.childList[1]?res.data.childList[1].childBirth:'')
              
              if (!i.health) {
                i.health = Object.assign(
                  {},
                  this.$options.data().form.childList.health
                );
                this.$set(i.health,'symptoms',[])
              }
              i.health.symptoms = this.computedList(i.health.symptoms,5)
            })
          }
          
          this.form.health.skins = this.computedList(this.form.health.skins,1)
          this.form.health.shapes = this.computedList(this.form.health.shapes,2)
          this.form.health.foods = this.computedList(this.form.health.foods,3)
          this.form.health.breasts = this.computedList(this.form.health.breasts,4)
          this.form.health.symptoms = this.computedList(this.form.health.symptoms,5)
          this.$nextTick(()=>{
            this.$refs.form.clearValidate()
          })
        }
      });
    },
    checkTel() {
      //   校验手机号，判断该手机号是否已注册/登记会员。若已登记，则提示“手机号已注册”并加载该会员的对应信息，功能自动由添加会员变成修改会员。
      if (!/^1[3456789]\d{9}$/.test(this.form.phone)) return;
      memDetail({
        phone: this.form.phone
      }).then(res => {
        if (res.data) {
          if (!res.data.accountOffList || res.data.accountOffList.length == 0) {
            this.$confirm("您已是本系统会员", "提示", {
              confirmButtonText: "确定",
              showCancelButton: false,
              type: "info"
            }).then(() => {
              this.$router.push("/basicDataCenter/phone" + this.form.phone);
            });
          } else {
            this.$confirm("您已是本系统本店会员，可直接列表查看", "提示", {
              confirmButtonText: "确定",
              showCancelButton: false,
              type: "info"
            }).then(() => {
              this.$router.push("/basicDataCenter/baseInfo");
              this.$store.commit("setAliveStatus", true); //保留列表页状态
              sessionStorage.setItem('keyTel',this.form.phone);
            });
          }
        }
      });
    },
    resetCreatData() {
      // 最后提交时，根据所处阶段和生产方式清空部分值
      if (this.form.health.procreate == 1) {
        // 妊娠
        this.form.health.menstrual = "";
        this.form.health.dueDate = "";
        this.form.health.dueStyle = "";
        this.form.health.lactation = "";
      } else if (this.form.health.procreate == 2) {
        // 产后
        this.form.health.menstrual = "";
        this.form.health.expectedDate = "";
      } else if (this.form.health.procreate == 3) {
        // 孕前
        this.form.health.dueDate = "";
        this.form.health.dueStyle = "";
        this.form.health.lactation = "";
        this.form.health.expectedDate = "";
      }
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.clickFalg = true;
          if (this.$store.state.userInfo.brandId == 1) {
            this.resetCreatData();
            // 婷美
            let post = this.submitDate;
            insertMem(post).then(res => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                sessionStorage.setItem("memId", res.data);
                // 进入消费密码设置页
                // this.$router.push("/basicDataCenter/setPsd");
                this.$store.commit("setAliveStatus", true);//保留列表页状态
                this.$router.push("/basicDataCenter/baseInfo");
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
              this.$nextTick(()=>{
                this.clickFalg = false;
              })
            });
          } else {
            // 儿推
            let post = this.childSubmitData;
            insertMem(post).then(res => {
              if (res.code == 1) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                sessionStorage.setItem("memId", res.data);
                // 进入消费密码设置页
                // this.$router.push("/basicDataCenter/setPsd");
                this.$store.commit("setAliveStatus", true);//保留列表页状态
                this.$router.push("/basicDataCenter/baseInfo");
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
              this.$nextTick(()=>{
                this.clickFalg = false;
              })
            });
          }          
        } else {
          this.clickFalg = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm("确定要重置会员信息？重置后内容将清空", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$refs.form.resetFields();
          this.form = Object.assign({}, this.$options.data().form);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },
    closeTab() {
      this.$store.commit("delete_tabs", this.$route.path);
      // 设置当前激活的路由
      if (this.options && this.options.length >= 1) {
        this.$store.commit(
          "set_active_index",
          this.options[this.options.length - 1].route
        );
        this.$router.push({ path: this.activeIndex });
      }
    },
    cancelEdit() {
      //编辑页的取消
      this.$confirm("若取消，将关闭该会员修改页，确定取消吗？", "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "继续修改",
        cancelButtonText: "确定取消",
        type: "warning"
      })
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.closeTab();
            this.$store.commit("setAliveStatus", true); //保留列表页状态
            this.$router.push("/basicDataCenter/baseInfo");
          }
        });
    },
    submitEdit() {
      // 编辑页提交
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.$store.state.userInfo.brandId == 1) {
            this.resetCreatData();
            // 婷美
            let postData = this.submitDate;
            this.submitDate.memberId = this.$route.params.memId;
            updateMem(postData).then(res => {
              if (res.code == 1) {
                // 关闭当前进入列表页
                this.closeTab();
                this.$store.commit("setAliveStatus", true); //保留列表页状态
                this.$router.push("/basicDataCenter/baseInfo");
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
            });
          } else {
            // 儿推
            let postData = this.childSubmitData;
            this.childSubmitData.memberId = this.$route.params.memId;
            updateMem(postData).then(res => {
              if (res.code == 1) {
                // 关闭当前进入列表页
                this.closeTab();
                this.$store.commit("setAliveStatus", true); //保留列表页状态
                this.$router.push("/basicDataCenter/baseInfo");
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.addMemberes {
  width: 100%;
  overflow: hidden;
  padding: 50px 50px 70px;
  .deleteChild {
    cursor: pointer;
    width: 22px;
    height: 22px;
    background: url(../../assets/images/store/dele.png) no-repeat center;
    position: absolute;
    top: 36px;
    right: 11px;
  }
  .childTitle {
    font-size: 17px;
    font-weight: bold;
    color: #444;
    width: 100px;
    text-align: right;
    padding-right: 12px;
    margin-bottom: 15px;
  }
  .myChild {
    background: #eff1f5;
    height: 66px;
    line-height: 66px;
    border-top: 1px dashed #c0c5cf;
    text-align: center;
    margin-bottom: 30px;
    .addChild {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .borTop {
    border-top: 1px dashed #c0c5cf;
    padding-top: 25px;
  }
}
</style>
<style lang="less">
.addMemberes .myselectTgas label {
  background: #abb1c3;
  height: 34px;
  line-height: 34px;
  padding: 0 14px;
  border-radius: 17px;
  margin: 0 6px 6px 0;
  &.is-active,
  &.is-checked {
    background: #f83b56;
    position: relative;
    &::after {
      content: "";
      width: 17px;
      height: 17px;
      position: absolute;
      background: url(../../assets/images/store/btn_select2.png) no-repeat
        center;
      background-size: contain;
      top: 0;
      right: -5px;
    }
  }
  .el-radio-button__inner,
  .el-checkbox-button__inner {
    background: none;
    border: none;
    padding: 0;
    color: #fff;
    box-shadow: none;
  }
}
.addMemberes .btnOptions {
  text-align: center;
  .el-button {
    width: 135px;
    height: 46px;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/addmems.vue